var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNew = function SvgNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "New offer"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2838"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2741"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffcf33",
    d: "m41.17 2.471 9.624 26a1.26 1.26 0 0 0 .732.737l26 9.616a1.252 1.252 0 0 1 0 2.348l-26 9.616a1.27 1.27 0 0 0-.732.737l-9.624 26a1.25 1.25 0 0 1-2.344 0l-9.62-26a1.24 1.24 0 0 0-.737-.737l-26-9.616a1.253 1.253 0 0 1 0-2.348l26-9.616a1.23 1.23 0 0 0 .737-.737l9.62-26a1.25 1.25 0 0 1 2.344 0",
    "data-name": "Path 6074"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#495867",
    d: "m13.283 3.236 2.706 7.317a.36.36 0 0 0 .208.208l7.317 2.706a.353.353 0 0 1 0 .663l-7.317 2.706a.36.36 0 0 0-.208.208l-2.706 7.317a.352.352 0 0 1-.659 0l-2.706-7.318a.36.36 0 0 0-.208-.208l-7.32-2.706a.355.355 0 0 1 0-.663l7.321-2.706a.36.36 0 0 0 .208-.208l2.706-7.317a.352.352 0 0 1 .659 0",
    "data-name": "Path 6075"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffcf33",
    d: "m64.833 9.433 1.742 4.712a.24.24 0 0 0 .134.134l4.712 1.742a.224.224 0 0 1 0 .423l-4.712 1.746a.22.22 0 0 0-.134.134l-1.742 4.708a.224.224 0 0 1-.423 0l-1.746-4.708a.2.2 0 0 0-.134-.134l-4.708-1.746a.224.224 0 0 1 0-.423l4.708-1.742a.22.22 0 0 0 .134-.134l1.746-4.712a.226.226 0 0 1 .423 0",
    "data-name": "Path 6076"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffcf33",
    d: "m13.861 58.791 1.738 4.713a.24.24 0 0 0 .134.134l4.712 1.742a.224.224 0 0 1 0 .423l-4.708 1.746a.22.22 0 0 0-.134.134l-1.742 4.708a.224.224 0 0 1-.423 0l-1.746-4.708a.2.2 0 0 0-.134-.134L6.85 65.803a.224.224 0 0 1 0-.423l4.708-1.742a.22.22 0 0 0 .134-.134l1.746-4.712a.226.226 0 0 1 .423 0",
    "data-name": "Path 6077"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#495867",
    d: "m67.881 56.989 2.706 7.317a.36.36 0 0 0 .208.208l7.317 2.706a.353.353 0 0 1 0 .663l-7.317 2.706a.36.36 0 0 0-.208.208l-2.706 7.317a.352.352 0 0 1-.659 0l-2.706-7.318a.36.36 0 0 0-.208-.208l-7.321-2.706a.355.355 0 0 1 0-.663l7.321-2.706a.36.36 0 0 0 .208-.208l2.706-7.317a.352.352 0 0 1 .659 0",
    "data-name": "Path 6078"
  }))))));
};
export default SvgNew;